// One range vocabulary for every screen. 28d = 4 whole weeks, so day-of-week charts are not skewed.
export const DEFAULT_RANGE = '28d';
export const RANGE_OPTIONS: Array<{ v: string; l: string }> = [
  { v: 'today', l: 'Hôm nay' },
  { v: 'yesterday', l: 'Hôm qua' },
  { v: '7d', l: '7 ngày' },
  { v: '28d', l: '28 ngày' },
  { v: '3m', l: '3 tháng' },
  { v: '6m', l: '6 tháng' },
  { v: 'all', l: 'Tất cả' },
];
